export const GET_LIST_DUNONHANVAY = "GET_LIST_DUNONHANVAY";
export const GET_LIST_DUNONHANVAY_SUCCESS = "GET_LIST_DUNONHANVAY_SUCCESS";
export const GET_LIST_DUNONHANVAY_FAILURE = "GET_LIST_DUNONHANVAY_FAILURE";

export const UPDATE_SEARCHTDATA_DUNONHANVAY = "UPDATE_SEARCHTDATA_DUNONHANVAY";
